export const STUDENT_DOCUMENT_TYPES = Object.freeze({
  NONE: 0,
  PASSPORT_STYLE_PHOTO: 1,
  DRIVER_LICENCE: 2,
  PASSPORT: 3,
  USI_SUPPORTING_DOCUMENT: 4,
});

export const STUDENT_DOCUMENT_DEFINITIONS = Object.freeze([
  { id: STUDENT_DOCUMENT_TYPES.PASSPORT_STYLE_PHOTO, name: "Passport Style Photo", key: "photo" },
  { id: STUDENT_DOCUMENT_TYPES.DRIVER_LICENCE, name: "Driver Licence", key: "licence" },
  { id: STUDENT_DOCUMENT_TYPES.PASSPORT, name: "Passport", key: "passport" },
  { id: STUDENT_DOCUMENT_TYPES.USI_SUPPORTING_DOCUMENT, name: "USI Supporting Document", key: "usi" },
]);

export const STUDENT_DOCUMENT_ACCEPT = ".jpg,.jpeg,.png,.pdf";
export const STUDENT_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
